export default __webpack_public_path__ + "locales/az/SharingPanel.json?hash=851c13229136b5c88b09802943974f4a";